export default function LogsReportProjectInfo({project, helical})  {
  const {data: {logs}} = project ?? {};

  return (
    <div className="grid">
      <div className="col-1-2">
        <table className="attribute-table">
          <tbody>
            <tr>
              <th>Project Name</th>
              <td>{project.name}</td>
            </tr>
            <tr>
              <th>Project Location</th>
              <td>{project.address}<br/>{project.city}, {project.state}  {project.zipcode}</td>
            </tr>
            <tr>
              <th>Installer</th>
              <td>{logs.installerName}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="col-1-2">
        <table className="attribute-table">
          <tbody>
            <tr>
              <th>Inspector</th>
              <td>{logs.inspectorName}<br/>{logs.inspectorCompany}</td>
            </tr>
            <tr>
              <th>Installation Equipment {!helical && " (Ram)"}</th>
              <td>{logs.installationEquipment}</td>
            </tr>
            {helical && (
              <tr>
                <th>Torque Monitoring Device</th>
                <td>{logs.torqueMonitoringDevice}</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}
